import Store from '../../../../../../Store'
import { mockImages } from '../getMockImage/getMockImage';


export const getIsCertificateEnabled = (langShort) => {
    const short = langShort ?? Store.getUserPlatformLangShort();
    return Object.keys(mockImages).includes(short)
}